import {
  Timestamp,
  db,
} from '@/plugins/firebase'

export class CommentDoc {
  static Collection = db.collection('comments')

  static listComments(pageId) {
    return CommentDoc.Collection.where('pageId', '==', pageId)
  }

  static addComment(author, email, rating, pageId, text) {
    return CommentDoc.Collection
      .add({
        author,
        email,
        rating,
        replies: [],
        pageId,
        text,
        timestamp: Timestamp.now(),
      })
  }

  static addReply(commentId, author, email, text) {
    return CommentDoc.Collection
        .doc(commentId)
        .get()
        .then((doc) => {
          const data = doc.data()

          data.replies.push({
            author,
            email,
            text,
            timestamp: Timestamp.now(),
          })

          return CommentDoc.Collection
              .doc(commentId)
              .update(data)
        })
  }
}

export class EventDoc {

  static Collection = db.collection('events')

  static ProfileDoc = {
    profiles: []
  }
  static SectionDoc = {
    content: 'New Section Description',
    header: 'New Section',
    headerColor: '',
    link: '',
    linkText: '',
    linkColor: '',
    images: [],
  }
  static SplitSectionDoc = {
    left: {
      content: 'Left Section Content',
    },
    right: {
      content: 'Right Section Content',
    },
    type: 'split',
  }
  static DOC = {
    archived: false,
    createdAt: null,
    endAt: null,
    image: {
      thumbnail: 'https://chefnaturelle.com/bg-white.jpg',
      url: 'https://chefnaturelle.com/bg-white.jpg',
    },
    modified: null,
    published: false,
    publishedAt: null,
    sections: [],
    startAt: null,
    subtitles: [],
    title: '',
    type: '',
  }

  id
  data

  static create(id, data) {
    const now = Timestamp.now()
    const _data = {
      ...EventDoc.DOC,
      ...data,
      createdAt: now,
      modified: now,
      sections: [
        {...EventDoc.SectionDoc},
      ]
    }

    return EventDoc.Collection
      .doc(id)
      .set(_data)
  }

  static get(id) {
    return EventDoc.Collection.doc(id)
      .get()
      .then((doc) => new EventDoc(id, doc.data()))
  }

  constructor(id, data) {
    this.id = id
    this.data = data
  }

  get description() {
    const subtitles = this.data.subtitles.join(' ')

    return `${this.data.title} - ${subtitles}`
  }

  get image() {
    return this.data.image
  }

  get published() {
    return this.data.published
  }

  get sections() {
    return this.data.sections
  }

  get subtitles() {
    return this.data.subtitles
  }

  get title() {
    return this.data.title
  }

  get titleColor() {
    return this.data.titleColor || 'white'
  }

  archive() {
    this.data.archived = true

    return this
  }

  archiveSection(index) {
    this.data.sections.splice(index, 1)

    return this
  }

  addImage(image) {
    this.data.image = {
      thumbnail: image.thumbnail,
      url: image.url,
    }

    return this
  }

  addProfiles(index) {
    this.data.sections.splice(index + 1, 0, {
      ...EventDoc.ProfileDoc,
    })

    return this
  }

  addSection(index) {
    this.data.sections.splice(index + 1, 0, {
      ...EventDoc.SectionDoc,
    })

    return this
  }

  addSplitSection(index) {
    this.data.sections.splice(index + 1, 0,  {
      ...EventDoc.SplitSectionDoc,
    })

    return this
  }

  duplicate(id, title, type) {
    const now = Timestamp.now()

    return EventDoc.Collection
      .doc(id)
      .set({
        ...this.data,
        title,
        type,
        archived: false,
        createdAt: now,
        endAt: null,
        modified: now,
        published: false,
        publishedAt: null,
        startAt: null,
      })
  }

  exists() {
    return this.data !== undefined
  }

  moveSectionDown(index) {
    const _section = this.data.sections.splice(index, 1)[0]

    this.data.sections.splice(index + 1, 0, _section)[0]

    return this
  }

  moveSectionUp(index) {
    const _section = this.data.sections.splice(index, 1)[0]

    this.data.sections.splice(index - 1, 0, _section)[0]

    return this
  }

  publish() {
    const published = this.published

    this.data.published = published ? false : true
    this.data.publishedAt = published ? null : Timestamp.now()

    return this
  }

  setEndTimestamp(timestamp) {
    if (timestamp != null) {
      this.data.endAt = timestamp
    }

    return this
  }

  setSectionContent(index, content) {
    this.data.sections[index].content = content

    return this
  }

  setSectionImages(index, images) {
    this.data.sections[index].images = images.map((image) => {
      return {
        position: image.position,
        thumbnail: image.thumbnail,
        url: image.url,
      }
    })

    return this
  }

  setSectionLink(index, url, name, color) {
    const section = this.data.sections[index]

    section.link = url
    section.linkText = name
    section.linkColor = color

    return this
  }

  setSectionProfiles(index, profiles) {
    this.data.sections[index].profiles = profiles.map((profile) => {
      return {
        description: profile.description,
        image: profile.image,
        name: profile.name,
      }
    })

    return this
  }

  setStartTimestamp(timestamp) {
    if (timestamp != null) {
      this.data.startAt = timestamp
    }

    return this
  }

  setTitle(index, color, title) {
    const section = this.data.sections[index]

    section.header = title
    section.headerColor = color

    return this
  }

  update(data) {
    if (!this.id) {
      return
    }

    this.data = {
      ...this.data,
      ...data,
      modified: Timestamp.now(),
    }

    return EventDoc.Collection
      .doc(this.id)
      .update(this.data)
  }
}

export class GalleryDocument {

  static Collection = db.collection('gallery')

  static add(image) {
    return GalleryDocument.Collection
        .add({
          created: Timestamp.now(),
          name: image.name,
          thumbnail: image.thumbnail,
          url: image.url,
        })
  }

  static list() {
    return GalleryDocument.Collection
        .orderBy('created', 'desc')
  }

  static delete(image) {
    return GalleryDocument.Collection
      .doc(image.id)
      .delete()
  }
}

export class ImageDocument {

  static Collection = db.collection('images')

  static create(name, thumbnail, url) {
    return ImageDocument.Collection
      .add({
        archived: false,
        createdAt: Timestamp.now(),
        name,
        thumbnail,
        url,
      })
  }

  static get(id) {
    return ImageDocument.Collection
      .doc(id)
      .get()
      .then((doc) => new ImageDocument(doc.id, doc.data()))
  }

  id
  data

  constructor(id, data) {
    this.id = id
    this.data = data
  }

  archive() {
    this.data.archived = true

    return this
  }

  update(data) {
    if (!this.id) {
      return this
    }

    this.data = {
      ...this.data,
      ...data,
      modified: Timestamp.now(),
    }

    return ImageDocument.Collection
      .doc(this.id)
      .update(this.data)
  }
}

export class ProfileDocument {

  static Collection = db.collection('profiles')

  static create(description, image, name) {
    return ProfileDocument.Collection
      .add({
        archived: false,
        createdAt: Timestamp.now(),
        description,
        image,
        name,
      })
  }

  static get(id) {
    return ProfileDocument.Collection
      .doc(id)
      .get()
      .then((doc) => new ProfileDocument(doc.id, doc.data()))
  }

  id
  data

  constructor(id, data) {
    this.id = id
    this.data = data
  }

  update(data) {
    if (!this.id) return this

    this.data = {
      ...this.data,
      ...data,
      modified: Timestamp.now(),
    }

    return ProfileDocument.Collection
      .doc(this.id)
      .update(this.data)
  }
}


export class PageDocument {

    static Collection = db.collection('pages')

    static PageDoc = {
      archived: false,
      created: null,
      image: {},
      modified: null,
      published: false,
      publishedAt: null,
      sections: [],
      tags: [],
      title: '',
      titleText: '',
      type: 'recipe',
    }
    static SectionDoc = {
      content: '<p>New Section Description</p>',
      link: '',
      linkText: '',
      linkColor: '',
      images: [],
    }
    static SplitSectionDoc = {
      left: {
        heading: 'Ingredients',
        content: '<p>Left Section Content</p>',
      },
      right: {
        heading: 'Method',
        content: '<p>Right Section Content</p>',
      },
      type: 'split',
    }

    static create(id, data) {
      const now = Timestamp.now()
      const _data = {
        ...PageDocument.PageDoc,
        ...data,
        created: now,
        modified: now,
        sections: [
          {...PageDocument.SectionDoc},
        ]
      }

      return PageDocument.Collection
        .doc(id)
        .set(_data)
    }

    static get(id) {
      return PageDocument.Collection.doc(id)
        .get()
        .then((doc) => new PageDocument(id, doc.data()))
    }

    constructor(id, data) {
      this.id = id
      this.data = data
    }

    get image() {
      return this.data.image
    }

    get published() {
      return this.data.published
    }

    get sections() {
      return this.data.sections
    }

    get tags() {
      return this.data.tags
    }

    get title() {
      return this.data.title
    }

    get titleText() {
      return this.data.titleText
    }

    archive() {
      this.data.archived = true

      return this
    }

    archiveSection(index) {
      this.data.sections.splice(index, 1)

      return this
    }

    addImage(image) {
      this.data.image = {
        thumbnail: image.thumbnail,
        url: image.url,
      }

      return this
    }

    addSection(index) {
      this.data.sections.splice(index + 1, 0, {
        ...PageDocument.SectionDoc,
      })

      return this
    }

    addSplitSection(index) {
      this.data.sections.splice(index + 1, 0,  {
        ...PageDocument.SplitSectionDoc,
      })

      return this
    }

    duplicate(id, title) {
      const now = Timestamp.now()

      return PageDocument.Collection
        .doc(id)
        .set({
          ...this.data,
          title,
          archived: false,
          created: now,
          modified: now,
          published: false,
          publishedAt: null,
        })
    }

    exists() {
      return this.data !== undefined
    }

    moveSectionDown(index) {
      const _section = this.data.sections.splice(index, 1)[0]

      this.data.sections.splice(index + 1, 0, _section)[0]

      return this
    }

    moveSectionUp(index) {
      const _section = this.data.sections.splice(index, 1)[0]

      this.data.sections.splice(index - 1, 0, _section)[0]

      return this
    }

    publish() {
      const published = this.published

      this.data.published = published ? false : true
      this.data.publishedAt = published ? null : Timestamp.now()

      return this
    }

    setSectionContent(index, content) {
      this.data.sections[index].content = content

      return this
    }

    setSectionImages(index, images) {
      this.data.sections[index].images = images.map((image) => {
        return {
          position: image.position,
          thumbnail: image.thumbnail,
          url: image.url,
        }
      })

      return this
    }

    setSectionLink(index, url, name, color) {
      const section = this.data.sections[index]

      section.link = url
      section.linkText = name
      section.linkColor = color

      return this
    }

    setSplitSectionContent(index, section) {
      this.data.sections[index] = section

      return this
    }

    update(data) {
      if (!this.id) {
        return
      }

      this.data = {
        ...this.data,
        ...data,
        modified: Timestamp.now(),
      }

      return PageDocument.Collection
        .doc(this.id)
        .update(this.data)
    }
}
